export default {

    exchangeUnitKWH (num) {
        if(!num) return {num: 0, unit: 'kWh'};
        let unit = 'kWh';
        if(num >= 0 && num <= 999) {
            unit = 'kWh'
        } else if(num >= 1000 && num <= 999999) {
            num = parseFloat(num / 1000).toFixed(2);
            unit = 'MWh'
        } else if(num >= 1000000 && num <= 999999999) {
            num = parseFloat(num / 1000000).toFixed(2);
            unit = 'GWh'
        }  else if(num >= 1000000000 && num <= 999999999999) {
            num = parseFloat(num / 1000000000).toFixed(2);
            unit = 'TWh'
        } 
        return {num: num, unit: unit};
    },

    exchangeUnitKW (num) {
        let unit = 'kW';
        if(!num) return {num: 0, unit: unit};
        if(num >= 0 && num <= 999) {
            unit = 'kW'
        } else if(num >= 1000 && num <= 999999) {
            num = parseFloat(num / 1000).toFixed(2);
            unit = 'MW'
        } else if(num >= 1000000 && num <= 999999999) {
            num = parseFloat(num / 1000000).toFixed(2);
            unit = 'GW'
        }  else if(num >= 1000000000 && num <= 999999999999) {
            num = parseFloat(num / 1000000000).toFixed(2);
            unit = 'TW'
        } 
        return {num: num, unit: unit};
    },
}